import {AgentIcon, CopilotIcon, SparklesFillIcon, TriangleDownIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Button} from '@primer/react'
import type {IntentDetectionMode} from '../../types/intent-detection-mode'

import styles from './ModeSelector.module.css'

const DISPLAY_INFO = {
  auto: {icon: SparklesFillIcon, label: 'Auto'},
  ask: {icon: CopilotIcon, label: 'Ask'},
  task: {icon: AgentIcon, label: 'Task'},
}

function ModeItem({
  selectedMode,
  mode,
  setMode,
}: {
  selectedMode: IntentDetectionMode
  mode: IntentDetectionMode
  setMode: (mode: IntentDetectionMode) => void
}) {
  const info = DISPLAY_INFO[mode]
  return (
    <ActionList.Item selected={mode === selectedMode} onSelect={() => setMode(mode)}>
      <ActionList.LeadingVisual>
        <info.icon />
      </ActionList.LeadingVisual>
      {info.label}
    </ActionList.Item>
  )
}

export function ModeSelector({
  selectedMode,
  setMode,
}: {
  selectedMode: IntentDetectionMode
  setMode: (mode: IntentDetectionMode) => void
}) {
  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <Button
          leadingVisual={DISPLAY_INFO[selectedMode].icon}
          trailingAction={TriangleDownIcon}
          aria-label={'Select how Copilot detects your intent'}
          className={styles.selectorButton}
        >
          {DISPLAY_INFO[selectedMode].label}
        </Button>
      </ActionMenu.Anchor>
      <ActionMenu.Overlay width="auto">
        <ActionList>
          <ActionList.Divider />
          <ActionList.Group selectionVariant={false}>
            <ModeItem mode={'auto'} selectedMode={selectedMode} setMode={setMode} />
            <ModeItem mode={'ask'} selectedMode={selectedMode} setMode={setMode} />
            <ModeItem mode={'task'} selectedMode={selectedMode} setMode={setMode} />
          </ActionList.Group>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
